import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { getAllContactUsRequest } from "../../../../Redux/Slices/Admin/adminSlice";

// Custom layout
import MainLayout from "Layouts/Main";

// Assets
import Colors from "../../../../Assets/SassConstants/colors.scss";
import InputBox from "Components/InputBox";

// Custom component
import NormalTable from "Components/NormalTable";

const ContactUsList = () => {
  // Initialize useNavigate
  const navigate = useNavigate();

  //Initialize redux
  const dispatch = useDispatch();

  //==================== List screen start ====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [contactUsList, setContactUsList] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({
    sortBy: null,
    sortOrder: 0,
  });
  const [noDataAvailable, setNoDataAvailable] = useState(false);

  const isLoading = useSelector((state) => state.common.getAllContactUsisLoading);

  const handlePageChange = async (page) => {
    await setCurrentPage(page);
    await getAllContactUs(page);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to first page on new search
  };

  useEffect(() => {
    getAllContactUs(currentPage);
  }, [sort, search]);

  //To handle the index
  const getDisplayedIndex = (currentPage, index) => {
    // Calculate the starting index for the current page
    const startingIndex = (currentPage - 1) * 8 + 1;
    return startingIndex + index;
  };

  //To get all contact us details
  const getAllContactUs = (page) => {
    dispatch(
      getAllContactUsRequest({
        page,
        search,
        sortBy: sort.sortOrder === 1 ? "ASC" : "DESC",
        orderBy: sort.sortBy,
        callBack: getAllContactUsCB,
      })
    );
  };

  //To handle the response of getAllContactUsRequest
  const getAllContactUsCB = (response) => {
  setTotalPages(response?.data?.pageMeta?.totalPages);
  setContactUsList(response?.data?.data_list);
  setNoDataAvailable(response?.data?.data_list?.length === 0);
};

  //==================== List screen end ====================

  const contactUsHeader = [
    { label: "S.No", isSort: false, key: "sno" },
    { label: "Company Name", isSort: true, key: "company_name" },
    { label: "Country", isSort: true, key: "country" },
    { label: "Industry", isSort: true, key: "industry" },
    { label: "Contact Name", isSort: true, key: "key_contact_name" },
    { label: "Email", isSort: false, key: "email" },
    { label: "Phone Number", isSort: false, key: "phoneNumber" },
  ];

  return (
    <MainLayout style={{ backgroundColor: Colors.grey_12 }}>
      <div className="contact-us-container">
        {/* Heading and Search Section */}
        <div className="contact-us-row contact-us-header-row">
          <h1 className="contact-us-heading">Contact Us Requests</h1>
          <div className="d-flex flex-row align-items-center gap-2 me-3">
            <InputBox
              name="search"
              isSearch={true}
              placeholder="Search"
              value={search}
              onChange={(e) => handleSearch(e)}
              inputStyle={{ width: "277px" }}
            />
          </div>
        </div>

        {/* Space */}
        <div className="contact-us-space"></div>

        {/* Combined Header and Dynamic Value Rows */}
        <div className="contact-us-table">
          <NormalTable
            loading={isLoading === "loading"}
            headers={contactUsHeader}
            sort={sort}
            setSort={setSort}
            currentPage={currentPage}
            noDataColspan={7}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            customStyle={{
              customTableHeaderContainer: "customContactUsTableHeader",
              customHeaderTitle: "customContactUsHeaderStartTitle",
              customTable: "customContactUsTable",
              customTableContainer: "customContactUsTableContainer",
            }}
            noDataLabel={noDataAvailable}
          >
            {contactUsList?.map((row, index) => {
              return (
                <tr key={index} style={{ position: "relative" }}>
                  <td>
                    <div className="TableDivisionStart ms-3 ps-1 mt-1">
                      {getDisplayedIndex(currentPage, index)}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {row.company_name ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {row.country ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {row.industry ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {row.key_contact_name ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {row.email ?? "-"}
                    </div>
                  </td>
                  <td>
                    <div className="TableDivisionStart ms-2 mt-1">
                      {row.country_code && row.phoneNumber
                        ? `${row.country_code} ${row.phoneNumber}`
                        : "-"}
                    </div>
                  </td>
                </tr>
              );
            })}
          </NormalTable>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactUsList;